import Cookies from 'cookies-js';

export default class Tracker {
  static store(key, value) {
    this.storeForHours(key, value, this.defaultLifetimeInHours());
  }

  static storeForHours(key, value, storeUntilInHours) {
    const now = new Date();
    Cookies.set(key, value, { expires: storeUntilInHours * 60 * 60 });
    Cookies.set(
      `${key}_expiration_info`,
      `Stored at ${now.toISOString()}, for ${storeUntilInHours} hours.`,
      { expires: storeUntilInHours * 60 * 60 }
    );
  }

  static defaultLifetimeInHours() {
    return 24;
  }

  static get(key) {
    return Cookies.get(key);
  }

  static getExpirationInfo(key) {
    return Cookies.get(`${key}_expiration_info`);
  }
}
